import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SectionProvider } from "./components/contexts/SectionContext";
import { AuthProvider } from "./components/contexts/AuthContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import Home from "./pages/home";
import AllNewsPage from "./pages/newsList";
import News from "./pages/news";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminNewsList from "./pages/admin/AdminNewsList";
import AdminNewsForm from "./pages/admin/AdminNewsForm";

export default function App() {
  return (
    <SectionProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/all-news" element={<AllNewsPage />} />
            <Route path="/news/:id" element={<News />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/news"
              element={
                <ProtectedRoute>
                  <AdminNewsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/news/new"
              element={
                <ProtectedRoute>
                  <AdminNewsForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/news/:id/edit"
              element={
                <ProtectedRoute>
                  <AdminNewsForm />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </SectionProvider>
  );
}
